export default "__VITE_ASSET__DU6n0PBc__"